import { Link } from "react-router-dom";
import { LogoMark } from "./Logo";

export const Footer = () => (
    <footer className="border-t border-white/[0.06] px-5 py-12 md:py-16">
        <div className="mx-auto flex max-w-6xl flex-col items-center gap-5 text-center">
            <LogoMark size={32} />
            <span className="text-[11px] font-bold tracking-[0.35em] text-acid">
                MONEYMUSCLE
            </span>
            <a
                href="mailto:hello@money-muscle.co.uk"
                data-testid="footer-email"
                className="text-sm text-[#8f8f89] transition-colors duration-300 hover:text-acid"
            >
                hello@money-muscle.co.uk
            </a>
            <Link
                to="/privacy"
                data-testid="footer-privacy-link"
                className="text-sm text-[#8f8f89] transition-colors duration-300 hover:text-acid"
            >
                Privacy Policy
            </Link>
            <p className="text-xs text-white/25">
                © MoneyMuscle — Fitness &amp; Finance. Simplified.
            </p>
        </div>
    </footer>
);
